module.exports = __webpack_public_path__ + "static/media/app-logo.9d62c19b.svg";